import { createI18n } from "vue-i18n/index.mjs";
import ru from './locales/ru'
import uz from './locales/uz'

const i18n = createI18n({
  locale: localStorage.getItem('media-locale') ? localStorage.getItem('media-locale') : 'uz',
  messages: {
    ru, uz
  },
});

export default i18n